module.exports = __webpack_public_path__ + "img/bar_chart.12551dc1.svg";